import { Box, Button, CircularProgress, Typography, styled, useTheme } from "@mui/material";

function OrderCancelButton({ item, onClick, justifyContent, alignItems, loading }) {
  const status = item?.stateId;
  const theme = useTheme();

  if (status === 2) {
    return (
      <Button
        variant={"contained"}
        sx={{
          minWidth: "58px",
          fontSize: "14px !important",
          fontWeight: "600",
        }}
        onClick={() => onClick(item)}
        size="small"
        color="error"
        disabled={loading}
      >
         {loading ? <CircularProgress size={20} /> : "Cancel"}
      </Button>
    );
  }

  if (status === 3) {
    return (
      <BoxState
        justifyContent={justifyContent || "center"}
        alignItems={alignItems || "center"}
        color={theme.palette.error.main}
      >
        <ion-icon lineHeight={0} name="close-circle-outline" />

        <Typography color="error.main" variant="h5" fontWeight={600}>
          Canceled
        </Typography>
      </BoxState>
    );
  }

  return "";
}

const BoxState = styled(Box)(({ theme, color }) => ({
  display: "flex",

  ".MuiTypography-root": {
    marginLeft: theme.spacing(1),
  },

  "ion-icon": {
    width: "20px",
    height: "20px",
    color: color,
  },
}));

export default OrderCancelButton;
